import { UserRole } from '../models/auth.model';

export const PRE_REGISTERED_LANDING_ROUTE = '/pre-enrollment-documents';

export const PRE_REGISTERED_ALLOWED_ROUTES = [
  '/dashboard',
  '/schedule',
  PRE_REGISTERED_LANDING_ROUTE,
  '/admissions/applicant-fields',
  '/inscription',
  '/payments',
  '/settings',
  '/aula-virtual',
];

const PRE_REGISTERED_STATUSES = ['provisional', 'preregistered'];

export function isPreRegisteredStatus(...values: Array<string | null | undefined>): boolean {
  return values.some((value) => PRE_REGISTERED_STATUSES.includes(normalizeStatus(value)));
}

export function canAccessStudentPortal(
  role: string | null | undefined,
  status: string | null | undefined,
): boolean {
  return normalizeStatus(role) === UserRole.Student || isPreRegisteredStatus(status, role);
}

export function isAdmissionsRoute(url: string): boolean {
  return PRE_REGISTERED_ALLOWED_ROUTES.some((route) => url.startsWith(route));
}

function normalizeStatus(value: string | null | undefined): string {
  return (value ?? '')
    .trim()
    .replace(/[\s_-]/g, '')
    .toLowerCase();
}
